// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripeProduct",
  "collectionKey": "stripe_products",
  "collectionName": "stripe_products",
  "i18nKey": "stripe_product",
  "camelizedLower": "stripeProduct",
  "name": "StripeProduct",
  "nameDasherized": "stripe-product",
  "pluralName": "stripe_products",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripePlan",
      "collectionName": "stripe_plans",
      "foreignKey": "stripe_product_id",
      "name": "stripe_plans",
      "macro": "has_many",
      "resource_name": "StripePlan",
      "through": null
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_subscriptions",
      "macro": "has_many",
      "resource_name": "StripeSubscription",
      "through": "stripe_plans"
    }
  ],
  "ransackable_attributes": [
    {
      "name": "active",
      "column": {
        "default": "0",
        "name": "active",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "caption",
      "column": {
        "default": null,
        "name": "caption",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": "1",
        "name": "livemode",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "package_dimensions_height",
      "column": {
        "default": null,
        "name": "package_dimensions_height",
        "null": true,
        "type": "decimal"
      }
    },
    {
      "name": "package_dimensions_length",
      "column": {
        "default": null,
        "name": "package_dimensions_length",
        "null": true,
        "type": "decimal"
      }
    },
    {
      "name": "package_dimensions_weight",
      "column": {
        "default": null,
        "name": "package_dimensions_weight",
        "null": true,
        "type": "decimal"
      }
    },
    {
      "name": "package_dimensions_width",
      "column": {
        "default": null,
        "name": "package_dimensions_width",
        "null": true,
        "type": "decimal"
      }
    },
    {
      "name": "product_type",
      "column": {
        "default": null,
        "name": "product_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "shippable",
      "column": {
        "default": "0",
        "name": "shippable",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "statement_descriptor",
      "column": {
        "default": null,
        "name": "statement_descriptor",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_attributes",
      "column": {
        "default": null,
        "name": "stripe_attributes",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "unit_label",
      "column": {
        "default": null,
        "name": "unit_label",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated",
      "column": {
        "default": null,
        "name": "updated",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "url",
      "column": {
        "default": null,
        "name": "url",
        "null": true,
        "type": "text"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "stripe_product",
  "primaryKey": "id"
}

/** Frontend model for StripeProduct. */
export default class StripeProduct extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }
}
